module.exports = __webpack_public_path__ + "static/media/logo.54ee1f4a.svg";